// extracted by mini-css-extract-plugin
module.exports = {"notFoundRow":"NotFound_notFoundRow_hkQC-","logo":"NotFound_logo_3IadY"};